import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate, redirect } from "react-router-dom";
// import { MdLogout } from "react-icons/md";
import { BiStar } from "react-icons/bi";
import { IoIosSearch } from "react-icons/io";
import logo from "../assets/logo.svg";
import profile_icon_light from "../assets/profile_icon_light.svg";
import profile_icon_dark from "../assets/profile_icon_dark.svg";
import ContainerLayout from "./ContainerLayout";
import useDebounce from "../components/Debounce/Debounce";
import { getSearchResult } from "../services/search.service";
import { persistedStore } from "../utils/store/Store";
import {
  addPointNotification,
  buyPointNotification,
  resetUserDetail,
} from "../utils/action/Action";
import "./header.scss";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  NavbarText,
} from "reactstrap";
import { useDispatch } from "react-redux";
import { IoMdLogOut } from "react-icons/io";
import { useSelector } from "react-redux";
// import { AiFillTaobaoSquare } from "react-icons/ai";
import { FaBars } from "react-icons/fa";
// import { HiMiniUserCircle } from "react-icons/hi2";

const Header = ({
  isUserLoggedIn,
  userAuthentication,
  userPoints,
  setUserPoints,
  pathName,
}) => {
  const [searchText, setSearchText] = useState("");
  const [debouceValue, setDebouceValue] = useState("");
  const [searchData, setSearchData] = useState({});
  const [nulldata, setnulldata] = useState("");
  const [dropdownMenuOpen, setMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const debounce = useDebounce();
  const navigate = useNavigate();
  const searchRef = useRef(null);
  const location = useLocation();
  const dispatch = useDispatch();
  const firstName = useSelector(
    (state) => state?.userDetailReducer?.userData?.firstName
  );
  const lastName = useSelector(
    (state) => state?.userDetailReducer?.userData?.lastName
  );

  const regex =
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

  const menuRef = useRef(null);

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);
  useEffect(() => {
    if (searchText?.length >= 3 && debouceValue) {
      const fetchSearch = async () => {
        let arr = [];

        await getSearchResult(searchText.trim()).then((res) => {
          Object.entries(res?.data?.data).map((item) => arr.push(item[1]));
          const allEqual = (arr) => arr.every((v) => v === arr[0]);
          const result = allEqual(arr);

          if (result === true) {
            setnulldata("nodata");
            setSearchData({});
          } else {
            setSearchData(res?.data?.data);
          }
        });
      };

      fetchSearch();
    }
  }, [debouceValue, searchText]);

  const handleLogout = (e) => {
    e.preventDefault();
    userAuthentication();
    // clear local storage except pathName
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    // set last pathName
    if (pathName === "/category-list") {
      localStorage.setItem("Category", location?.state?.categoryName);
    }
    localStorage.setItem("pathName", pathName);
    persistedStore.purge();
    setUserPoints();
    dispatch(resetUserDetail());
    let obj = {
      notification: false,
    };
    dispatch(addPointNotification(obj));
    let object = {
      notification: false,
    };
    dispatch(buyPointNotification(object));
    redirect("/sign-in");
  };

  const handleSearch = (e) => {
    const newData = e?.target?.value?.replace(/^\s+/, "").replace(regex, "");
    setSearchText(newData);

    if (newData?.length > 2) {
      debounce(() => setDebouceValue(newData), 300);
      setIsModalOpen(true);
    } else {
      setDebouceValue("");
      setSearchData([]);
      setnulldata(null);
      setIsModalOpen(false);
    }
  };

  const handleSearchItem = (data) => {
    navigate("/search-everywhere", {
      state: { data: searchText.trim(), key: data },
    });
    setIsModalOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsModalOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  console.log("isOPen", isOpen);

  return (
    <header
      className="nt-header"
      style={{
        background:
          location.pathname === "/" ? "rgba(255, 250, 246, 0.5)" : "#fffcf8",
        boxShadow:
          location.pathname === "/" ? "" : "0px 2px 30px 0px #0000001A",
      }}
    >
      <ContainerLayout>
        <div className="nt-header-wrapper">
          <Link to="/">
            <img src={logo} alt="brand-logo" className="nt-header-logo" />
          </Link>

          <div
            className="nt-header-search"
            ref={searchRef}
            style={{
              border:
                location.pathname === "/"
                  ? "1.34px solid #FFFFFF99"
                  : "1.34px solid #0000004D",
              boxShadow:
                location.pathname === "/"
                  ? "2.01px 2.01px 4.68px 0px #00000033 inset"
                  : "",
              background: location.pathname !== "/" ? "#00000005" : "",
            }}
          >
            <input
              placeholder="Where are you going?"
              value={searchText}
              onChange={handleSearch}
              onFocus={() => setIsModalOpen(true)}
              className={
                location.pathname === "/" ? "nt-input-white" : "nt-input-black"
              }
            />

            {isModalOpen && Object.keys(searchData)?.length > 0 && (
              <div className="nt-auto_search">
                <div
                  className="nt-inner_div nt-search_every"
                  style={{ gap: "10px", marginBottom: "10px" }}
                >
                  <IoIosSearch size={20} color="black" />
                  <span
                    onClick={() => handleSearchItem("searcheverywhere")}
                    className="nt-search-span"
                  >
                    Search Everywhere
                  </span>
                </div>

                <div className="nt-scroll_container">
                  {Object.entries(searchData)?.map(
                    (item, index) =>
                      item[1] > 0 && (
                        <div
                          className="nt-inner_div"
                          key={index}
                          onClick={() => handleSearchItem(item[0])}
                        >
                          <div>
                            <span className="nt-cate_name">{searchText}</span>{" "}
                            in{" "}
                            <span className="nt-cate_name">
                              {item[0]?.replace("Count", "")}
                            </span>
                          </div>
                          <div className="nt-cate_count">{item[1]}</div>
                        </div>
                      )
                  )}
                </div>
              </div>
            )}

            {isModalOpen && nulldata === "nodata" && (
              <div className="nt-auto_search">
                <div className="nt-inner_div">
                  <span>No Records Found</span>
                </div>
              </div>
            )}
          </div>

          <ul className="nt-header-links">
            <li
              className={
                location.pathname === "/" ? "nt-li-white" : "nt-li-black"
              }
            >
              <Link to="/">Home</Link>
            </li>
            <li
              className={
                location.pathname === "/" ? "nt-li-white" : "nt-li-black"
              }
            >
              <Link to="/my-routes">My Routes</Link>
            </li>
            <li
              className={
                location.pathname === "/" ? "nt-li-white" : "nt-li-black"
              }
            >
              <Link to="/help">Help</Link>
            </li>
          </ul>

          <Link to="/plan-your-trip" className="nt-header-button">
            <span className="nt-header-button-text">Plan Your Trip</span>
          </Link>

          <div className="nt-header-user-container nt-mobile-menu">
            <Dropdown
              className="custom-dropdown"
              isOpen={dropdownOpen}
              toggle={toggleDropdown}
            >
              <DropdownToggle className="custom-dropdown-toggle" caret={false}>
                <FaBars />
              </DropdownToggle>

              <DropdownMenu className="custom-dropdown-menu" end>
                <DropdownItem
                  tag={Link}
                  to="/my-routes"
                  onClick={() => setDropdownOpen(false)}
                  className="custom-dropdown-item"
                >
                  My Routes
                </DropdownItem>

                <DropdownItem
                  tag={Link}
                  to="/help"
                  onClick={() => setDropdownOpen(false)}
                  className="custom-dropdown-item"
                >
                  Help
                </DropdownItem>

                <DropdownItem
                  tag={Link}
                  to="/plan-your-trip"
                  onClick={() => setDropdownOpen(false)}
                  className="custom-dropdown-item"
                >
                  Plan Your Trip
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>

          <section className="nt-header-user-container">
            {isUserLoggedIn && (firstName || lastName) ? (
              <div className="nt-header-links">
                <li
                  className={
                    location.pathname === "/" ? "nt-li-white" : "nt-li-black"
                  }
                >
                  {firstName + " " + lastName}
                  <br />
                </li>
              </div>
            ) : null}

            <Dropdown
              className="custom-dropdown"
              toggle={() => {
                setMenuOpen(!dropdownMenuOpen);
              }}
              isOpen={dropdownMenuOpen}
              color="black"
            >
              <DropdownToggle className="custom-dropdown-toggle">
                <img
                  src={
                    location.pathname === "/"
                      ? profile_icon_light
                      : profile_icon_dark
                  }
                  alt="user"
                  className="nt-header-profile-icon"
                />
              </DropdownToggle>
              <DropdownMenu className="custom-dropdown-menu">
                {isUserLoggedIn && (
                  <DropdownItem
                    className="custom-dropdown-item0"
                    onClick={() => navigate("/points")}
                  >
                    <NavbarText className="navabar_text">
                      <Link to="/points">Num of Credits : {userPoints}</Link>
                    </NavbarText>
                  </DropdownItem>
                )}
                {isUserLoggedIn && (
                  <DropdownItem
                    className="custom-dropdown-item"
                    onClick={() => navigate("/points")}
                  >
                    <Link to="/points" className="points_icon">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        className="custom-icon"
                      >
                        <circle
                          cx="12"
                          cy="12"
                          r="11"
                          stroke="currentColor"
                          strokeWidth="2"
                          fill="none"
                        />
                        <path
                          d="M7.4375 6.9375H8.70312L15.8281 15.6719V6.9375H17.1172V18H15.9062L8.72656 9.20312V18H7.4375V6.9375Z"
                          fill="currentColor"
                        />
                        <path d="..." fill="currentColor" />
                      </svg>
                      Credits
                    </Link>
                  </DropdownItem>
                )}

                {isUserLoggedIn ? (
                  <DropdownItem
                    className="custom-dropdown-item"
                    onClick={() => navigate("/favourites")}
                  >
                    <Link to="favourites">
                      <BiStar size={20} />
                      Favourites
                    </Link>
                  </DropdownItem>
                ) : null}
                {/* <DropdownItem>
					<Button
						onClick={sync}
					>
						<MdSync size={20} />
						Sync
					</Button>
				</DropdownItem> */}
                {isUserLoggedIn ? (
                  <DropdownItem
                    className="custom-dropdown-item"
                    onClick={(e) => handleLogout(e)}
                  >
                    <Link to="#" onClick={(e) => handleLogout(e)}>
                      <IoMdLogOut size={20} />
                      Logout
                    </Link>
                  </DropdownItem>
                ) : (
                  <DropdownItem
                    className="custom-dropdown-item"
                    onClick={() => navigate("/sign-in")}
                  >
                    <Link to="/sign-in">
                      <IoMdLogOut size={20} />
                      Log In
                    </Link>
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>
          </section>

          {/* <Link to="/">
            <img
              src={
                location.pathname === "/"
                  ? profile_icon_light
                  : profile_icon_dark
              }
              alt="user"
              className="nt-header-profile-icon"
            />
          </Link>
*/}
        </div>
      </ContainerLayout>
    </header>
  );
};

export default Header;
